import React from 'react';

const PageHeader = () => {
  return (
    <section className="page-header">
      <div className="page-header__bg" style={{ backgroundImage: 'url(assets/images/5.jpg)' }}></div>
      <div className="page-header__shape-bg" style={{ backgroundImage: 'url(assets/images/shapes/page-header-shape-bg.png)' }}></div>
      <div className="page-header__shape-1 float-bob-x">
        <img src="assets/images/shapes/page-header-shape-1.png" alt="" />
      </div>
      <div className="page-header__shape-2 float-bob-y">
        <img src="assets/images/shapes/page-header-shape-2.png" alt="" />
      </div>
      <div className="container">
        <div className="page-header__inner">
          <h2>About Us</h2>
          <div className="thm-breadcrumb__box">
            <ul className="thm-breadcrumb list-unstyled">
              <li><a href="index.html">Home</a></li>
              <li><span className="fas fa-angle-right"></span></li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
